import { SimpleFormDialog } from '@procureai/ui-modules-mui';
import { useTranslation } from 'react-i18next';

import { SavingForm } from '../SavingForm/SavingForm';
import { savingFormDefaultValues, savingFormSchema, SavingFormData } from '../SavingForm/SavingForm.schema';
import { SavingHistorySection } from '../SavingHistorySection/SavingHistorySection';
import { I18nNamespace } from '~/common/types';

import { useEditSavingBackend } from './useEditSavingBackend';

interface EditSavingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  id: string | null;
}

export const EditSavingDialog = ({ open, onOpenChange, id }: EditSavingDialogProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'Savings.editDialog' });
  const backend = useEditSavingBackend(id);

  return (
    <SimpleFormDialog<SavingFormData>
      key={id ?? 'new'}
      open={open}
      onOpenChange={onOpenChange}
      useBackend={() => backend}
      title={t('title')}
      schema={savingFormSchema}
      defaultValues={savingFormDefaultValues}
      submitLabel={t('submitLabel')}
      cancelLabel={t('cancelLabel')}
      slotProps={{
        content: { className: 'w-[calc(100vw-2rem)] sm:max-w-3xl' },
      }}
    >
      {({ saving, loading }) => (
        <>
          <SavingForm mode="edit" disabled={saving} loading={loading} />
          <div className="mt-6">
            <SavingHistorySection id={id} />
          </div>
        </>
      )}
    </SimpleFormDialog>
  );
};
